(function (Translator) {
    // lt
    Translator.add("recaptcha.title", "Ar tu esi robotas?", "EvpThemeBundle", "lt");
    Translator.add("recaptcha.description", "\u0160is prane\u0161imas skirtas patikrinti ar nar\u0161o \u017emogus, bei i\u0161vengti automatini\u0173 sistem\u0173 tikrinimo", "EvpThemeBundle", "lt");
    Translator.add("rate_list.rate.bg_kbcbank", "KBC Bank suma", "EvpThemeBundle", "lt");
})(Translator);
